import { GetAllGGNotificationLotDTO, GetAllGGNotificationLotFiltersDTO, GetAllGGNotificationTabDTO, GetAllGGNotificationTabFiltersDTO, GGNotificationLotDTO, GGNotificationTabDTO } from "./dto";
import { GGNotificationCoCServiceImpl } from "./serviceImpl";

export interface GGNotificationCocService {
    /* LOT */
    CreateGGNotificationLot(data: GGNotificationLotDTO): Promise<void>
    DeleteGGNotificationLot(id: string): Promise<void>
    GetAllGGNotificationLot(filters: GetAllGGNotificationLotFiltersDTO): Promise<GetAllGGNotificationLotDTO>
    GetGGNotificationLotById(id: string): Promise<GGNotificationLotDTO>

    /* TAB */
    UpdateGGNotificationTab(data: GGNotificationTabDTO, id: string): Promise<void>
    GetAllGGNotificationTab(filters: GetAllGGNotificationTabFiltersDTO): Promise<GetAllGGNotificationTabDTO>
    GetGGNotificationTabById(id: string): Promise<GGNotificationTabDTO>
}

export function NewGGNotificationCoCService(): GGNotificationCocService {
    return new GGNotificationCoCServiceImpl()
}